import config from "./config";

export default params => {
  config("linker", params);
};
